// src/app/features/playbook/playbook.routes.ts
import { Routes } from '@angular/router';
import { adminGuard } from '../../core/guards';

export const playbookRoutes: Routes = [
  {
    path: 'playbooks',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/vault/playbook-vault.component').then((m) => m.PlaybookVaultComponent),
      },
      {
        path: 'formations/:id/edit',
        loadComponent: () =>
          import('./components/formations-tab/formation-editor.component').then((m) => m.FormationEditorComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'plays/:id',
        loadComponent: () =>
          import('./components/plays-tab/play-concept-detail.component').then((m) => m.PlayConceptDetailComponent),
      },
      {
        path: 'play-variants/:id/edit',
        loadComponent: () =>
          import('./components/plays-tab/play-variant-editor.component').then((m) => m.PlayVariantEditorComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'templates/:id/edit',
        loadComponent: () =>
          import('./components/shared/template-editor.component').then((m) => m.TemplateEditorComponent),
        canActivate: [adminGuard],
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./components/playbooks-tab/playbook-detail.component').then((m) => m.PlaybookDetailComponent),
      },
    ],
  },
];
